import Mention from "@tiptap/extension-mention";

export const CustomMention = Mention.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      email: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-email"),
        renderHTML: (attributes) => {
          return {
            "data-email": attributes.email,
          };
        },
      },
      class: {
        default: "mention",
        parseHTML: () => "mention",
        renderHTML: () => ({
          class: "mention",
        }),
      },
      "data-model": {
        default: "user",
        parseHTML: () => "user",
        renderHTML: () => ({
          "data-model": "user",
        }),
      },
    };
  },
});
